import React from 'react';
import { Box, Center, Flex } from '@chakra-ui/react';
import Vimeo from '@u-wave/react-vimeo';
import { findT } from '@interness/web-core/src/components/_helpers';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import BrandsSubnavigation from '@interness/brands-addon/src/components/modules/BrandsSubnavigation/BrandsSubnavigation';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import BrandPageWrapper from '@interness/ecommerce-addon/src/components/BrandPageWrapper/BrandPageWrapper';
import Overridable from '@interness/web-core/src/components/Overridable/Overridable';
import ResponsiveIFrame from '@interness/web-core/src/components/structure/iFrame/iFrame';
import Gallery from '../../../../components/Gallery/Gallery';
import CallToAction from '../../../../components/CallToAction/CallToAction';
import { jsx as ___EmotionJSX } from "@emotion/react";
const BrandPageTemplate = props => {
  const data = props.data.directusBrands.brand;
  const type = props.data.directusBrandTypes;
  const translations = findT(data.translations, props.pageContext.lang);
  const typeTranslations = findT(type.translations, props.pageContext.lang);
  if (!data.gallery_images_square[0]) {
    console.log('Quadratische Bilder fehlen');
  }
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: data.display_name
  }), ___EmotionJSX(BrandsSubnavigation, {
    type: data.type.type
  }), ___EmotionJSX(Spacer, null), ___EmotionJSX(Flex, {
    flexWrap: "wrap",
    maxWidth: "1024px",
    m: "auto",
    width: "95%",
    justifyContent: "center"
  }, ___EmotionJSX(Box, {
    width: ['100%', '100%', data.gallery_images_square[0] ? '50%' : '100%', data.gallery_images_square[0] ? '50%' : '100%'],
    mt: ['6', '6', '0', '0']
  }, ___EmotionJSX(Center, null, ___EmotionJSX(Box, {
    width: "240px",
    height: "80px"
  }, ___EmotionJSX(Logo, {
    logo: data.logo.localFile,
    title: data.display_name,
    svgWidth: "240px",
    svgHeight: "80px",
    imageWidth: "240px"
  }))), ___EmotionJSX(Box, {
    p: 12,
    textAlign: 'justify',
    dangerouslySetInnerHTML: {
      __html: translations.description
    }
  })), data.gallery_images_square[0] && ___EmotionJSX(Box, {
    width: ['80%', '80%', '50%', '50%']
  }, ___EmotionJSX(Gallery, {
    images: data.gallery_images_square
  }))), data.youtube_video_id && ___EmotionJSX(Box, {
    maxWidth: "1024px",
    m: "auto",
    width: "95%"
  }, ___EmotionJSX(ResponsiveIFrame, {
    src: `https://www.youtube-nocookie.com/embed/${data.youtube_video_id}?rel=0&amp;controls=0`,
    title: `YoutubeVideo`,
    type: 'youtube'
  }), ___EmotionJSX(Spacer, null)), ___EmotionJSX(Overridable, {
    fieldName: "vimeo_video_id",
    collection: "brand",
    itemId: data.directus_id,
    type: "text_override",
    render: override => {
      if (!override && !data.vimeo_video_id) {
        return null;
      }
      return ___EmotionJSX(Box, {
        maxWidth: "1024px",
        m: "auto",
        width: "95%"
      }, ___EmotionJSX(Spacer, null), ___EmotionJSX("div", {
        style: {
          position: 'relative',
          'width': '100%',
          paddingTop: '56.25%'
        }
      }, ___EmotionJSX(Vimeo, {
        responsive: true,
        video: `https://vimeo.com/${data.vimeo_video_id}`,
        dnt: true,
        style: {
          border: '0',
          position: 'absolute',
          height: '100%',
          width: '100%',
          top: '0',
          left: '0'
        }
      })), ___EmotionJSX(Spacer, null));
    }
  }), ___EmotionJSX(Box, {
    maxWidth: "1024px",
    m: "auto",
    width: "95%"
  }, ___EmotionJSX(BrandPageWrapper, {
    category: typeTranslations.slug,
    title: data.display_name,
    manufacturer: data.slug
  })), ___EmotionJSX(Spacer, null), ___EmotionJSX(CallToAction, null));
};
export default BrandPageTemplate;
const query = "3224719453";